<template>
  <div class="virtual_guard__divider">
    <p 
      class="virtual_guard__phone_prompt_text" 
      v-for="text of promptMessage.split('\n')" 
      :key="text">{{ text }}</p>
    <div 
      class="virtual_guard__actions touch_selectors" 
      v-if="steep !== 2 && steep !== 5 && !failed">
      <button 
        @click="clickOnValidate()" 
        class="virtual_guard__button">
        <span>{{ steep === 1 ? 'Si. Por favor!' : 'Si' }}</span>
        <span class="virtual_guard__button_icon"><talk-icon></talk-icon></span>
      </button>
      <button 
        @click="clicOnCancel()" 
        class="virtual_guard__button">
        <span>{{ steep === 1 ? 'No, gracias.' : 'No' }}</span>
        <span class="virtual_guard__button_icon"><talk-icon></talk-icon></span>
      </button>
    </div>

    <div 
      v-show="getIsTouch() && show_keyboard"
      class="virtual_guard__keyboard_container">
      <input
        v-model="phoneNumber"
        class="keyboard-input virtual_guard__keyboard_input"
        readonly
        placeholder="Por favor, indique su número de teléfono.'"
      />
      <div 
        ref="keyboard" 
        class="virtual_guard__keyboard"></div>
      <div 
        @click="successPhoneNumber()"
        class="virtual_guard__keyboard--success">Enviar</div>
    </div>

  </div>
</template>

<script>
import initSpeachRecognition from '../../utils/SpeachRecognition';
import speakText from '../../utils/SpeachSynthesis';
import TalkIcon from "../../components/shared/icons/TalkIcon.vue";
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  props: {
    sublocation_id: {
      required: true,
      type: String,
    }
  },
  components: {
    TalkIcon,
  },
  data() {
    return {
      promptMessage: '',
      phoneNumber: '',
      recognition: null,
      recognitionActive: false,
      steep: 1,
      counter: 0,
      maxFails: 3,
      failed: false,
      globalTimeOut: null,
      keyboard: null,
      show_keyboard: false
    };
  },
  mounted() {
    if (!this.getIsTouch()){
      this.startGlobalTimeout();
    }
    this.speak('El tiempo de respuesta puede tardar unos minutos más.\n¿Deseas dejar tu número para contactarte más tarde?');
    this.keyboard = new Keyboard(this.$refs.keyboard, {
      layout: {
        default: [
          "1 2 3",
          "4 5 6",
          "7 8 9",
          "{shift} 0 {bksp}",
          // "{enter}"
        ]
      },
      display: {
        "{bksp}": "⌫",
        // "{enter}": "Enviar",
        "{shift}": "Cancelar"
      },
      theme: "hg-theme-default virtual_guard__keyboard", // Puedes agregar tus propias clases
      onChange: input => {
        this.phoneNumber = input;
      },
      onKeyPress: button => {
        // Aquí puedes manejar eventos especiales si lo deseas
        console.log(button)
        if(button == '{shift}'){
          this.show_keyboard = false
          this.clicOnCancel()
        }
        if(button == '{enter}'){
          this.steep = 4
          this.clickOnValidate()
          // this.speak('Gracias. Hemos guardado su número de teléfono. Le contactaremos pronto.').then(() => {
          //   this.savePhoneNumber();
          // })
        }
      }
    });
  },
  beforeDestroy() {

  },
  watch: {
    phoneNumber(val) {
      if (this.keyboard) {
        this.keyboard.setInput(val);
      }
    }
  },
  methods: {
    successPhoneNumber(){
      this.steep = 4
      this.clickOnValidate()
    },
    clearTimeout() {
      if (this.globalTimeOut) {
        this.clearTimeout(this.globalTimeOut);
        this.globalTimeOut = null;
      }
    },
    startGlobalTimeout() {
      this.clearTimeout();
      this.globalTimeOut = setTimeout(() => {
        this.failed = true;
        this.speak('No se completó el proceso a tiempo. El sistema ha cancelado la solicitud.').then(() => {          
          console.log("Parar Proceso")
          if(this.getIsTouch()){
            console.log(this.getIsTouch())
            this.updateShowPhonePrompt(false)
          }else{
            this.$emit('closePhoneValidation');
          } 
        });
      }, 90000)
    },
    initSpeechRecognition() {
      try {
        this.recognition = initSpeachRecognition({
          onResult: this.validateNumber,
          onError: (error) => {
            console.error('Error en reconocimiento:', error);
            this.recognitionActive = false;
          },
          onEnd: () => {
            this.recognitionActive = false;
          },
          onStart: () => {
            this.recognitionActive = true;
          }
        });

        this.recognition.onstart = () => {
          this.recognitionActive = true;
        };

      } catch (error) {
        console.error('SpeechRecognition no soportado', error);
      }
    },
    async speak(text) {
      this.promptMessage = text;
      return speakText({
        text,
        delayBeforeResolve: 300,
        onEnd: () => {
          if (!this.getIsTouch()){
            if (this.steep === 2)
              this.recognition.start();
          }
        },
      });
    },
    validateNumber(result) {
      const digits = result.replace(/\D/g, '');
      if (digits.length > 0) {
        this.phoneNumber = digits;
        this.steep = 3;
        this.clickOnValidate();
      } else {
        if (this.counter < this.maxFails) {
          const self = this;
          this.counter++;
          this.speak('No he podido captar ningún número. Por favor, inténtelo de nuevo.').then(() => {
            self.recognition.start();
          });
        } else {
          this.failed = true;
          this.speak('Se han detectado demasiados intentos fallidos. El proceso ha sido cancelado.').then(() => {
            if(this.getIsTouch()){
              this.updateShowPhonePrompt(false)
            }else{
              this.$emit('closePhoneValidation');
            } 
          });
        }
      }
    },
    clickOnValidate() {
      switch (this.steep) {
        case 1: {
          this.steep = 2;
          this.counter++;
          console.log(" Es touch?", this.getIsTouch())
          if(this.getIsTouch()){
            this.speak('Por favor, digite su número de teléfono.')
            this.show_keyboard = true
          }else{
            this.speak('Por favor, diga su número de teléfono.').then(() => {
              this.initSpeechRecognition();
              this.recognition.start();
            });
          }
        } break;
        case 3: {
          this.steep = 4;
          const formattedNumber = this.phoneNumber.split('').join(' ');
          this.speak(`He capturado el número ${formattedNumber}. ¿Es correcto?.`);
        } break;
        case 4: {
          this.steep = 5;
          this.show_keyboard = false
          this.speak('Gracias. Hemos guardado su número de teléfono. Le contactaremos pronto.').then(() => {
            this.savePhoneNumber();
          })
        }
      }
    },
    clicOnCancel() {
      const synth = window.speechSynthesis;
      synth.cancel();
      if (this.steep === 4) {
        if (this.counter < this.maxFails) {
          this.steep = 1;
          this.clickOnValidate();
        } else {
          this.failed = true;
          this.speak('Se han detectado demasiados intentos fallidos. El proceso ha sido cancelado.').then(() => {
            if(this.getIsTouch()){
              this.updateShowPhonePrompt(false)
            }else{
              this.$emit('closePhoneValidation');
            } 
          });
        }
        return;
      }
      this.failed = true;
      this.speak('Entendido, que tenga un buen día.').then(() => {
        this.$emit('closePhoneValidation');
        this.updateShowPhonePrompt(false)
      });
    },
    savePhoneNumber() {
      console.log("Svae Phone Number")
      const number = Number(this.phoneNumber);
      try {
        this.$http.get('company_monitorings/get_number_virtual_agent', {
          headers: {
            'X-Device_ID': this.getDeviceId(),
            Authorization: process.env.VUE_APP_JITSI_TOKEN_AUTHORIZATION,
          },
          params: {
            mobile_virtual_agent: number,
            sublocation_id: this.sublocation_id,
          }
        }).then(() => {
          if(this.getIsTouch()){
            this.updateShowPhonePrompt(false)
          }else{
            this.$emit('closePhoneValidation');
          }          
        });
      } catch (err) {
        console.error(err);
        alert(JSON.stringify(err));
      }
    }
  },
};
</script>
<style scoped>
/* Personalización de los botones y el fondo */


</style>
